// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/jet-blast-prop-wash.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/jet-blast-prop-wash/jet-blast-prop-wash.js';

mount([g0]);
